/**
 * 年度预算编制
 * chenxiaojian 2020-02-14
 */
import React from 'react';
import { Row, Col, Button, Select, Empty, Card, DatePicker, Table, Progress, Input, InputNumber, Form } from 'antd';
import moment from 'moment';
import http from '../../../axios/http';
import messager from '../../ui/messager';
//周报信息生成
import ReportWeekCreate from './ReportWeekCreate';
import { fixedNumber } from '../../../util/util';
import './report.css';
import { global_data } from '../../ui/auth'

class WeekWriteIndexForm extends React.Component {

    //统计信息的数据
    statisticFields = [{
        "field": "hasStaff",
        "text": "在职编制人数",
    }, {
        "field": "hasEpiboly",
        "text": "在职外包人数",
    }, {
        "field": "budgetStaff",
        "text": "预算编制人数",
    }, {
        "field": "budgetEpiboly",
        "text": "预算外包人数",
    }, {
        "field": "addStaff",
        "text": "本周入职编制人数",
    }, {
        "field": "minusStaff",
        "text": "本周离职编制人数",
    }, {
        "field": "addEpiboly",
        "text": "本周入职外包人数",
    }, {
        "field": "minusEpiboly",
        "text": "本周离职外包人数",
    }];

    businessColumns = [{
        title: '项目',
        dataIndex: 'itemName',
        width: '15%',
        colSpan: 2,
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["rowSpan"],
                    colSpan: row["colSpan"] != null ? row["colSpan"] : 1
                },
            };
        },
    }, {
        title: '分项',
        dataIndex: 'subName',
        width: '10%',
        colSpan: 0,
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    colSpan: row["colSpan"] != null ? 0 : 1
                },
            };
        },
    }, {
        title: '本周执行',
        dataIndex: 'week',
        width: '15%',
        render: (text, record, index) => {
            if (this.state.editFlag && this.state.editIndex === record.tableIndex) {
                let field = (record["subName"] === "数量" ? "incomeNum" : "incomeMoney") + "-" + record["reportId"];
                return this.createDom("number", field, text);
            } else {
                return text;
            }
        }
    }, {
        title: '本月累计执行',
        dataIndex: 'month',
        width: '15%',
    }, {
        title: '年度预算目标',
        dataIndex: 'yearBudget',
        width: '15%',
    }, {
        title: '年度累计执行',
        dataIndex: 'year',
        width: '15%',
    }, {
        title: '年度执行进度',
        dataIndex: 'reportId',
        width: '15%',
        render: (text, record, index) => {
            return <Progress percent={fixedNumber((record["year"] / record["yearBudget"] * 100).toFixed(2), 2)} />;
        }
    }];

    workColumns = [{
        title: '项目',
        dataIndex: 'mainName',
        width: '15%',
        colSpan: 2,
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row["rowSpan"] != null ? row["rowSpan"] : 0
                },
            };
        },
    }, {
        title: '分项',
        dataIndex: 'itemName',
        width: '10%',
        colSpan: 0
    }, {
        title: '本周工作计划',
        dataIndex: 'thisPlan',
        width: '25%',
        onCell: () => tableTextStyle,
        render: (value, record, index) => {
            return this.string2Html(value);
        }
    }, {
        title: '本周主要工作内容',
        dataIndex: 'thisWork',
        width: '25%',
        onCell: () => tableTextStyle,
        render: (value, record, index) => {
            if (this.state.editFlag && this.state.editIndex === record.tableIndex) {
                return this.createDom("textarea", "thisWork-" + record["reportId"], value);
            } else {
                return this.string2Html(value);
            }
        }
    }, {
        title: '下周工作计划',
        dataIndex: 'nextPlan',
        width: '25%',
        onCell: () => tableTextStyle,
        render: (value, record, index) => {
            if (this.state.editFlag && this.state.editIndex === record.tableIndex) {
                return this.createDom("textarea", "nextPlan-" + record["reportId"], value);
            } else {
                return this.string2Html(value);
            }
        }
    }];

    string2Html = (value) => {
        value = value == null ? value : value.replace(/\n/g, '<br/>');
        return <div dangerouslySetInnerHTML={{ __html: value }} />
    }

    state = {
        visible: false, //修改框显示
        editData: {},   //修改数据
        //查询数据
        queryData: {
            year: moment().year(),
            month: moment().format('YYYY-MM'),
            orgCode: '',
            orgName: ''
        },
        orgList: [],    //有编制预算的部门信息
        data: [],   //用于页面展示渲染的数据
        //编辑状态
        editFlag: false,
        editIndex: -1,
    };

    componentDidMount() {
        //获取已经创建了预算部门的信息
        this.loadBudgetOrg();
    }

    //查询有点知预算的组织机构信息
    loadBudgetOrg = () => {
        http.get({
            url: "/yearBudget/findBudgetOrg",
            data: { year: this.state.queryData.year },
            success: (res) => {
                let queryData = this.state.queryData;
                if (res != null && res.length > 0) {
                    queryData["orgCode"] = res[0].code;
                    queryData["orgName"] = res[0].name;
                    this.loadData(queryData);
                } else {
                    queryData["orgCode"] = "";
                    queryData["orgName"] = "";
                    res = [];
                    //没有任何机构，说明也不会有周报信息
                    this.setState({ data: [] });
                }
                this.setState({ orgList: res, queryData: queryData });
            }
        });
    }

    //加载数据，用于页面渲染
    loadData = (queryData) => {
        http.get({
            url: "/reportWeek/findWeekReport",
            data: queryData,
            success: (res) => {
                if (res != null && res.length > 0) {
                    for (let i = 0; i < res.length; i++) {
                        let subNode = res[i].subNode;
                        let business = [];  //业务项目
                        let work = [];  //工作项目
                        let itemName = "收入合计";
                        if (res[i].orgName != null && res[i].orgName.startsWith("财务")) {
                            itemName = "经营利润";
                        }
                        let businessSum = {
                            "week": 0,
                            "month": 0,
                            "year": 0,
                            "yearBudget": 0,
                            "itemName": itemName,
                            "colSpan": 2,
                            "key": "-0",
                            "rowSpan": 1,
                        };
                        let sumFlag = 0;
                        if (subNode != null && subNode.length > 0) {
                            for (let j = 0; j < subNode.length; j++) {
                                if (subNode[j].type === 1) {
                                    let num = {
                                        "tableIndex": i,
                                        "key": "" + subNode[j]["reportId"] + "-0",
                                        "itemName": subNode[j]["itemName"],
                                        "subName": "数量",
                                        "week": subNode[j]["incomeNum"],
                                        "month": subNode[j]["monthNum"],
                                        "year": subNode[j]["yearNum"],
                                        "yearBudget": subNode[j]["numBudget"],
                                        "reportId": subNode[j]["reportId"],
                                        "rowSpan": 2,
                                    };
                                    let money = {
                                        "tableIndex": i,
                                        "key": "" + subNode[j]["reportId"] + "-1",
                                        "itemName": subNode[j]["itemName"],
                                        "subName": "金额",
                                        "week": subNode[j]["incomeMoney"],
                                        "month": subNode[j]["monthMoney"],
                                        "year": subNode[j]["yearMoney"],
                                        "yearBudget": subNode[j]["moneyBudget"],
                                        "reportId": subNode[j]["reportId"],
                                        "rowSpan": 0,
                                    };
                                    if(itemName === "经营利润"){
                                        //针对财务部的信息做特殊处理
                                        let factor = 1;
                                        if(subNode[j]["itemName"] === "收入"){
                                            factor = 0;
                                        }else if(subNode[j]["itemName"] === "毛利"){
                                            factor = 1;
                                        }else if(subNode[j]["itemName"] === "税金及费用"){
                                            factor = -1;
                                        }
                                        businessSum["week"] += money["week"] * factor;
                                        businessSum["month"] += money["month"] * factor;
                                        businessSum["year"] += money["year"] * factor;
                                        businessSum["yearBudget"] += money["yearBudget"] * factor;
                                    }else{
                                        businessSum["week"] += money["week"];
                                        businessSum["month"] += money["month"];
                                        businessSum["year"] += money["year"];
                                        businessSum["yearBudget"] += money["yearBudget"];
                                    }

                                    //针对销售服务部做特殊处理
                                    if(num.itemName === "期末库存"){
                                        num.month="/"
                                        num.year="/"
                                        num.yearBudget="/"
                                        money.month="/"
                                        money.year="/"
                                        money.yearBudget="/"
                                    }


                                    if (subNode[j]["onlyMoney"] === 1) {
                                        //money["colSpan"] = 2;
                                        money["rowSpan"] = 1;
                                    } else {
                                        business.push(num);
                                    }
                                    business.push(money);
                                    sumFlag++;
                                } else if (subNode[j].type === 2) {
                                    let s = subNode[j]["subNode"];
                                    if (s == null || s.length === 0) {
                                        subNode[j]["rowSpan"] = 1;
                                        subNode[j]["tableIndex"] = i;
                                        work.push(subNode[j]);
                                    } else {
                                        s[0]["mainName"] = subNode[j]["itemName"];
                                        s[0]["rowSpan"] = s.length;
                                        s.forEach(item => {
                                            item["tableIndex"] = i;
                                            work.push(item)
                                        });
                                    }
                                }
                            }


                            if (sumFlag > 1) {
                                business.push(businessSum);
                            }
                            res[i]["business"] = business;
                            res[i]["work"] = work;
                        }
                    }
                }
                this.setState({ data: res });
            }
        });
    }

    hiddenModal = () => {
        this.setState({ visible: false, editData: {} });
    };

    hiddenModalCreate = () => {
        this.setState({ visible: false, editData: {} });
    }

    //新增
    create = () => {
        let queryData = this.state.queryData;
        let year = queryData["year"];
        let orgCode = queryData.orgCode;
        let orgName = queryData.orgName;
        let editData = { "year": year, "orgCode": orgCode, "orgName": orgName };
        this.setState({ visible: true, editData: editData });
    }

    //修改
    update = (index, e) => {
        if (this.state.editFlag === true) {
            messager.confirm("是否放弃保存正在填写的周报信息？", () => {
                this.setState({ editFlag: true, editIndex: index });
            });
        } else {
            this.setState({ editFlag: true, editIndex: index });
        }
    }

    //保存数据
    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            let json = {};
            let array = [];
            for (let key in values) {
                let temp = key.split("-");
                if (json[temp[1]] == null) {
                    json[temp[1]] = {};
                    array.push(json[temp[1]]);
                }
                json[temp[1]][temp[0]] = values[key];
                json[temp[1]]["reportId"] = temp[1];
            }
            http.post({
                url: '/reportWeek/saveWeekReport',
                data: { "weekJson": JSON.stringify(array) },
                success: (res) => {
                    this.loadData(this.state.queryData);
                    this.cancelUpdate();
                    messager.notify("保存成功！");
                }
            });
        });
    }

    cancelUpdate = () => {
        this.setState({ editFlag: false, editIndex: -1 });
    }

    //删除
    delete = (id, e) => {
        http.post({
            url: "/yearBudget/delteYearBudget",
            data: { id: id },
            success: (res) => {
                this.state.loadData(this.state.queryData);
                messager.notify("删除成功！");
            }
        });
    }

    queryMonthStart = (date, dateString) => {
        let { queryData } = this.state;
        let oldYear = queryData.year;
        let newYear = date.year();
        queryData.year = newYear;
        queryData.month = date.format("YYYY-MM")
        this.setState({ queryData: queryData });
        //如果没有改变年份，则不用再加载部门数据，直接加载查询数据，否则需先加载部门数据
        if (oldYear === newYear) {
            this.loadData(queryData);
        } else {
            this.loadBudgetOrg();
        }
    }


    orgSelect = (value, option) => {
        let queryData = this.state.queryData;
        queryData["orgCode"] = value;
        queryData["orgName"] = option.props.children;
        this.setState({ queryData: queryData });
        this.loadData(queryData)
    }

    extra = (index) => {
        let dom = [];
        if (this.state.editFlag && this.state.editIndex === index) {
            dom.push(<Button key="save" type="primary" onClick={this.save}>保存</Button>);
            dom.push(<Button key="cancel" onClick={this.cancelUpdate} style={{ marginLeft: '20px' }}>取消</Button>);
        } else {
            if(global_data.authCode.includes("REPORT_WEEK_WRITE_UPDATE")){
                dom.push(<Button key="edit" type="primary" onClick={this.update.bind(this, index)}>修改</Button>);
            }
        }
        return dom;
    }

    /**
     * 创建编辑节点
     * @param domType 节点类型
     * @param field 节点字段
     * @param value 操作的值,用来初始化
     */
    createDom = (domType, field, value) => {
        const { form } = this.props;
        const { getFieldDecorator } = form;
        let itemDom = (
            <Form.Item style={{ margin: 0 }}>
                {
                    getFieldDecorator(field, {
                        //rules: item.rules,
                        initialValue: value,
                    })(
                        domType === "number" ?
                            <InputNumber precision={0} style={{ width: '90%' }} />
                            : domType === "textarea" ?
                                <Input.TextArea rows={4} />
                                : <Input />
                    )
                }
            </Form.Item>
        );
        return itemDom;
    }

    render() {
        return (
            <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                <Row>
                    <Col span={24}>
                        <DatePicker.MonthPicker onChange={this.queryMonthStart} placeholder="月份" allowClear={false}
                            defaultValue={moment().startOf('month')} />
                        <Select onChange={this.orgSelect} value={this.state.queryData.orgCode} allowClear={false} style={{ width: "200px", margin: '0 10px' }}>
                            {this.state.orgList.map(item => (
                                <Select.Option key={item.code}>{item.name}</Select.Option>
                            ))}
                        </Select>
                        {global_data.authCode.includes("REPORT_WEEK_WRITE_ADD")?
                        <Button type="primary" onClick={this.create} style={{ "float": "right" }}>创建</Button>
                        :""}
                    </Col>
                </Row>
                <Row>
                    {this.state.data == null || this.state.data.length === 0 ?
                        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        :
                        this.state.data.map((value, index) => {
                            return <Col span={24} style={{ margin: "10px 0" }} key={index}>
                                <Card title={"第" + value['weekNum'] + "周（" + value["startDate"] + "~" + value["endDate"] + "）"} bordered={true} extra={this.extra(index)}>
                                    <Card.Grid style={gridStyle} kye="基本信息">
                                        <Row>
                                            {this.statisticFields.map((item, subIndex) => {
                                                return <Col span={6} key={subIndex}>
                                                    <div className="numLable">{item.text + "："}</div>
                                                    <div className="numValue">
                                                        {this.state.editFlag && this.state.editIndex === index && subIndex > 3 ?
                                                            this.createDom("number", item.field + "-" + value["reportId"], value[item.field]) :
                                                            value[item.field]
                                                        }
                                                    </div>
                                                    {/* <span className="numValue">{value[item.field]}</span> */}
                                                    {/* <Statistic title={item.text} value={value[item.field]}
                                                        formatter={(val) => this.state.editFlag && this.state.editIndex === index && subIndex > 3 ?
                                                            this.createDom("number", item.field + "-" + value["reportId"], val) : val} /> */}
                                                </Col>;
                                            })}
                                        </Row>
                                    </Card.Grid>
                                    <Card.Grid style={gridStyle} kye="执行计划">
                                        <Table rowKey="key" columns={this.businessColumns} dataSource={value["business"]} tableLayout="fixed" pagination={false} bordered={true} />
                                    </Card.Grid>
                                    <Card.Grid style={gridStyle} kye="工作任务">
                                        <Table rowKey="code" columns={this.workColumns} dataSource={value["work"]} tableLayout="fixed" pagination={false} bordered={true} />
                                    </Card.Grid>
                                </Card>
                            </Col>
                        })
                    }
                </Row>
                <ReportWeekCreate
                    visible={this.state.visible}
                    onCancel={this.hiddenModalCreate.bind(this)}
                    editData={this.state.editData}
                    successCallback={this.loadData}
                    queryData={this.state.queryData}
                />
            </div>
        )
    }
}

const gridStyle = {
    width: '100%',
    textAlign: 'center',
};

const tableTextStyle = {
    style: {
        overflow: 'visible',
        whiteSpace: 'normal',
    }
}

const WeekWriteIndex = Form.create()(WeekWriteIndexForm);

export default WeekWriteIndex;